// ── PRIX SELON LA RÉGION DU VISITEUR ────────────────────────────
// Détectée avec le fuseau horaire du navigateur, AVANT le premier rendu (le module est évalué avant React) :
// le bon prix s’affiche dès le premier affichage, sans saut de mise en page. Euro par défaut.
//   Europe/Zurich → CHF · America/… → CAD · tout le reste (France, Belgique, Luxembourg…) → EUR
// EUR et CHF : livre 27 (barré 159), bonus 37 / 27 / 27 / 27 / 37 = 155, total 314 → 27.
// CAD : livre 37 (barré 219), bonus 49 / 37 / 37 / 37 / 49 = 209, total 428 → 37.

export type Currency = 'EUR' | 'CHF' | 'CAD';

const NBSP = ' ';

const TABLE: Record<Currency, { main: number; anchor: number; bonuses: number[]; symbol: string }> = {
  EUR: { main: 27, anchor: 159, bonuses: [37, 27, 27, 27, 37], symbol: '€' },
  CHF: { main: 27, anchor: 159, bonuses: [37, 27, 27, 27, 37], symbol: 'CHF' },
  CAD: { main: 37, anchor: 219, bonuses: [49, 37, 37, 37, 49], symbol: `$${NBSP}CA` },
};

function detectCurrency(): Currency {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz === 'Europe/Zurich') return 'CHF';
    if (tz.startsWith('America/')) return 'CAD';
  } catch (_err) {
    // Intl indisponible : on garde l’euro
  }
  return 'EUR';
}

export const currency: Currency = detectCurrency();
const t = TABLE[currency];

/** Format français : nombre, espace insécable, symbole → « 27 € », « 27 CHF », « 37 $ CA », « 0,52 € ». */
export function formatMoney(amount: number): string {
  const n = Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace('.', ',');
  return `${n}${NBSP}${t.symbol}`;
}

const bonusTotal = t.bonuses.reduce((sum, v) => sum + v, 0);
const totalValue = t.anchor + bonusTotal;

export const prices = {
  currency,
  /** Prix du jour sans symbole (pour le grand prix de l’offre) */
  amount: String(t.main),
  symbol: t.symbol,
  main: formatMoney(t.main),
  anchor: formatMoney(t.anchor),
  bonuses: t.bonuses.map(formatMoney),
  bonusTotal: formatMoney(bonusTotal),
  totalValue: formatMoney(totalValue),
  savings: formatMoney(totalValue - t.main),
  perWeek: formatMoney(Math.round((t.main / 52) * 100) / 100),
};
